import {v4 as uuidV4} from "uuid";
import { queryConfigValue } from "@/apis/common";
import CryptoJS from 'crypto-js'

export function getIMEI() {
  if (process.browser && typeof window.localStorage !== 'undefined') {
    let IMEI = localStorage.getItem('IMEI');
    if (IMEI === null) {
      IMEI = uuidV4();
      localStorage.setItem('IMEI', IMEI);
    }

    return IMEI;
  }
  return '';
}

export const getGuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
  var r = (Math.random() * 16) | 0,
    v = c == 'x' ? r : (r & 0x3) | 0x8;
  return v.toString(16);
});

// 获取渠道
export function appCode() {
  const referrer = document.referrer.split('?')[1] || window.location.href.split('?')[1]
  const obj = {}
  if (referrer) {
    const referrArr = referrer.split('&');
    for (let i = 0; i < referrArr.length; i++) {
      obj[referrArr[i].split('=')[0]] = referrArr[i].split('=')[1]
    }
  }
  const nowParams = location.search.replace(/^\?/, '')
  const objParams = nowParams.split('&');
  const obj2 = {}
  for (let i = 0; i < objParams.length; i++) {
    obj2[objParams[i].split('=')[0]] = objParams[i].split('=')[1]
  }
  return Object.assign({}, obj, obj2)
}

// 获取IP信息
export async function getIpConfig() {
  const ipInfo = sessionStorage.getItem("IP");
  if(ipInfo && ipInfo!== '{}') {
    const location = JSON.parse(ipInfo);
    const arr = [location.country, 0, location.province, location.city, location.isp]
    return {
      Ip: location.ip,
      IpAddr: arr.join('|')
    }
  } else {
    try {
      const res = await queryConfigValue({key: 'IPAPI'});
      if(!res) return {}
      // const ipResponse = await fetch('https://api.ipdatacloud.com/v2/query?key=1032b765959d11eeaa2b00163e25360e');
      const ipResponse = await fetch('https://api.ipdatacloud.com/v2/query?key=' + res);
      const ipData = await ipResponse.json();
      const location = ipData.data.location || {};
      sessionStorage.setItem("IP", JSON.stringify(location));
      const arr = [location.country, 0, location.province, location.city, location.isp]
      return {
        Ip: location.ip,
        IpAddr: arr.join('|')
      }
    } catch(e) {
      return {}
    }
  }
}

// CBC加密
export function encryptCBC(str, key = '1eSAaqepg71Dpj98', iv = 'shmfdWQyrLRFBNXK') {
  const ciphertext = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(str),
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return ciphertext.toString();
}

// CBC解密
export function decryptCBC(encryptedStr, key = '1eSAaqepg71Dpj98', iv = 'shmfdWQyrLRFBNXK') {
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedStr);
  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: ciphertext,
    },
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}
// 检测域名是否可用，返回可用的链接
export async function getActiveDomain(urls) {
  console.log('urls', urls)

  if (!urls) { return urls }
  const domains = urls.split(',');
  if(domains.length < 2) {
    return domains[0];
  }
  for (let domain of domains) {
    if (await testDomain(domain)) {
      console.log('可用域名', domain)

      return domain;
    }
  }
  console.log('No domain reachable')
  return domains[0];
};

const testDomain = async (url) => {
  if (!url) { return false }
  try {
    const res = await fetch(`${url}/ping`, { method: 'HEAD', mode: 'no-cors' });
    return res.status < 400;
  } catch {
    return false;
  }
};
// ---------------------------------------------------------------------------
// 配置接口(/webapi/scania-hs.do)鉴权用的 JWT
// secret / iss 需与服务端保持一致；未配置时不带 Authorization 头
// ---------------------------------------------------------------------------
// 工具函数：Base64Url 编码
export function base64url(source) {
  // 将 Base64 编码转为 Base64Url 编码（替换 +/ 为 -_ 并去掉 =）
  let encoded = CryptoJS.enc.Base64.stringify(source);
  encoded = encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return encoded;
}

// 获取当前时间戳 + 300 秒
export function getCurrentTimestampPlusFiveMinutes() {
  return Math.floor(Date.now() / 1000) + 300;
}

// 主函数：生成 JWT token
export function generateJWTToken() {
  const secret = 'xkNSCZZ9AgMBAAGjggNVMIIDUTAO';

  // Header
  const header = {
    alg: 'HS256',
    typ: 'JWT'
  };

  // Payload
  const payload = {
    iss: 'mtoa8Pd7fd1AwfaurTAF7FEVE4',
    exp: getCurrentTimestampPlusFiveMinutes()
  };

  // 转为 JSON 字符串
  const headerStr = JSON.stringify(header);
  const payloadStr = JSON.stringify(payload);

  // Base64Url 编码
  const encodedHeader = base64url(CryptoJS.enc.Utf8.parse(headerStr));
  const encodedPayload = base64url(CryptoJS.enc.Utf8.parse(payloadStr));

  // 拼接签名前的内容
  const signingInput = `${encodedHeader}.${encodedPayload}`;

  // HMAC-SHA256 签名
  const signature = CryptoJS.HmacSHA256(signingInput, secret);
  const encodedSignature = base64url(signature);

  // 最终 token
  const jwtToken = `${encodedHeader}.${encodedPayload}.${encodedSignature}`;

  return jwtToken;
}